var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume-text-editor"},[_c('quill-editor',{class:[{'list-styles':_vm.listStyles},this.item.listStyle,'mt-4'],attrs:{"value":_vm.itemContent,"options":_vm.editorOption},on:{"change":function($event){return _vm.setContent($event.html)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }